import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef } from 'react';
import { PlusOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, Popconfirm } from 'antd';
import axios from 'axios';
import { DateFormat } from '../../../../components/FormattersTS';
import HasPermissions from "../../../../../../containers/HasPermissions";
import { axiosErrorHandler, showSuccessNotification } from '../../../../../../swzutils';
import { isUserMultiTenant } from "../../../../../../swzutils/UserPermissionsUtil";
import PaginatedFilterableTable, {} from "../../../../components/table/PaginatedFilterableTable";
import { loggedInUserSelector } from "../../../../../../store/slice/auth";
import { useAppSelector } from "../../../../../../store";
const SpecialRequirementsTable = () => {
    const tableRef = useRef(null);
    const loggedInUser = useAppSelector(loggedInUserSelector);
    const refresh = () => {
        tableRef.current?.fetch();
    };
    const disableSpecialRequirement = (specialRequirement) => {
        axios.delete('/admin/v1/special-requirements/' + specialRequirement.id)
            .then(( /*response*/) => {
            showSuccessNotification('Special Requirement has been disabled');
            refresh();
        })
            .catch(axiosErrorHandler);
    };
    const columns = [{
            title: 'Title',
            key: 'title',
            width: "10%",
            className: "nowrap",
            render: (text, record) => {
                return (record.title);
            }
        }, {
            title: 'Accept Declaration',
            key: 'acceptDeclaration',
            width: '30%',
            dataIndex: 'acceptDeclaration'
        }, {
            title: 'Complete Declaration',
            key: 'completeDeclaration',
            width: '30%',
            dataIndex: 'completeDeclaration'
        }, {
            title: 'Disabled',
            key: 'disabledAt',
            width: '5%',
            dataIndex: 'disabledAt',
            render: (text, record) => (_jsx(DateFormat, { value: record.disabledAt }))
        }, {
            title: 'Profile',
            key: 'tenantName',
            dataIndex: ['tenant', 'name'],
            width: '20%',
            condition: isUserMultiTenant(loggedInUser)
        }, {
            title: 'Action',
            key: 'action',
            width: "5%",
            render: (text, record) => (_jsx(Popconfirm, { title: "Are you sure to disable this special requirement?", onConfirm: () => disableSpecialRequirement(record), okText: "Yes", cancelText: "No", children: _jsx(Button, { children: "Disable" }) }))
        }];
    return (_jsxs("article", { className: "article swz-fixed-table-article", children: [_jsx("h2", { className: "article-title", children: "Special Requirements" }), _jsxs("div", { className: "table-operations clearfix", children: [_jsx(HasPermissions, { permissions: ['admin:specialRequirement:create'], children: _jsx(Button, { href: "#/app/consignments/special-requirements/edit/new", title: "Add a new Special Requirement", icon: _jsx(PlusOutlined, {}), children: "Add a new Special Requirement" }) }), _jsx(Button, { className: "pull-right", onClick: refresh, title: "Refresh", icon: _jsx(ReloadOutlined, {}) })] }), _jsx(PaginatedFilterableTable, { tableKey: 'specialRequirementsTable', ref: tableRef, dataUri: "/admin/v1/special-requirements", columns: columns, refreshOnSelectedTenantChanged: true })] }));
};
export default SpecialRequirementsTable;
